import { AnalyticsEvent, AnalyticsEventName } from './events';

export interface EventMeta {
  funnelStep: number;
  log?: 'info' | 'warn';
}

export const EVENT_META: Record<AnalyticsEventName, EventMeta> = {
  'page.viewed': { funnelStep: 1 },
  'transaction.loaded': { funnelStep: 2 },
  'payment.method_recreated': { funnelStep: 2, log: 'info' },
  'payment.confirm_clicked': { funnelStep: 3 },
  'payment.decline_clicked': { funnelStep: 3 },
  // Причина отмены, названная клиентом. Живёт рядом с самой отменой и на том же шаге: событие
  // приходит только когда причину выбрали, поэтому его отсутствие значит «не сказал».
  'payment.cancel_reason': { funnelStep: 3, log: 'info' },
  // CPAYMENT-1730: уход к мерчанту без отмены заявки — отдельное событие, иначе его нельзя
  // отличить от отмены, а именно на нём меряется эффект правки.
  'payment.leave_clicked': { funnelStep: 3, log: 'info' },
  // CPAYMENT-1731: показ попапа «мало времени» и продление по его кнопке — отдельная пара.
  // Клик нельзя мерить через `payment.confirm_clicked`: в него попадают все переходы к чеку, и
  // эффект самого попапа (сколько клиентов он вернул из EXPIRED) в нём не виден.
  'payment.low_time_shown': { funnelStep: 3, log: 'info' },
  'payment.low_time_extend_clicked': { funnelStep: 3, log: 'info' },
  'payment.retry_search_clicked': { funnelStep: 3, log: 'info' },
  'receipt.uploaded': { funnelStep: 3, log: 'info' },
  // CPAYMENT-1786: the receipt flow, step by step. Until now it had a single success-only event, so
  // a client who never managed to upload was indistinguishable from one who never tried.
  'payment.paid_clicked': { funnelStep: 3, log: 'info' },
  // CPAYMENT-1822: the pick step. `picker_silent` is `warn` — it is the shape in which "the client
  // could not attach anything" arrives, and before it that outcome produced no record at all.
  'receipt.picker_opened': { funnelStep: 3, log: 'info' },
  'receipt.pick_cancelled': { funnelStep: 3, log: 'info' },
  'receipt.pick_empty': { funnelStep: 3, log: 'warn' },
  'receipt.picker_silent': { funnelStep: 3, log: 'warn' },
  'receipt.file_selected': { funnelStep: 3, log: 'info' },
  'receipt.file_rejected': { funnelStep: 3, log: 'warn' },
  // CPAYMENT-1821: the pick could not be read at all. `warn`, because unlike a rejected format this
  // is not the client choosing the wrong file — it is a receipt we failed to take.
  'receipt.file_unreadable': { funnelStep: 3, log: 'warn' },
  'receipt.upload_started': { funnelStep: 3, log: 'info' },
  'receipt.upload_failed': { funnelStep: 3, log: 'warn' },
  'receipt.already_uploaded': { funnelStep: 3, log: 'info' },
  // CPAYMENT-1717: what the client did on the page and how the visit ended. `variant.selected`
  // sits on step 2 — it happens before a requisite exists.
  'variant.selected': { funnelStep: 2, log: 'info' },
  'requisite.copied': { funnelStep: 3, log: 'info' },
  'page.hidden': { funnelStep: 3, log: 'info' },
  'page.returned': { funnelStep: 3, log: 'info' },
  'state.final_shown': { funnelStep: 4, log: 'info' },
};

export const isConversionEvent = (event: AnalyticsEvent): boolean =>
  event.name === 'state.final_shown' && event.payload.status === 'COMPLETED';
